import store from '../../../store'
import create from './create.vue';
import create_enity from './create_enity.vue';

window.PLOMBS_MAKE =  new Vue({
	store,
	el: '#sb_plombs',
	name : "SB_PLOMBS",
	data () {
		return {

		}
	},
	created () {

	},
	components : {
		plombs_create : create,
		create_enity,
	}
})


